import BNBCOIN from "../assets/coins/BNB.svg";
import BUSD from "../assets/coins/BUSD.svg";
import USDC from "../assets/coins/USDC.svg";
import USDT from "../assets/coins/USDT.svg";
import UST from "../assets/coins/UST.png";
export const coinList = [
  {
    id: 1,
    icon: BNBCOIN,
    name: "BNB",
    address: "",
  },
  {
    id: 2,
    icon: USDC,
    name: "USDC",
    address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
  },
  {
    id: 3,
    icon: USDT,
    name: "USDT",
    address: "0x55d398326f99059ff775485246999027b3197955",
  },
  {
    id: 4,
    icon: BUSD,
    name: "BUSD",
    address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
  },
  {
    id: 5,
    icon: UST,
    name: "UST",
    address: "0x23396cf899ca06c4472205fc903bdb4de249d6fc",
  },
];
